import { isPreviewAvailable, type UploadPreviewAvailability } from './isPreviewAvailable';

export const MAX_CONCURRENT_UPLOAD_PREVIEWS = 10;

export type UploadNeedingPreview = UploadPreviewAvailability & {
  id: string;
  imageBase64?: string;
  previewFailed?: boolean;
};

export const getUploadsNeedingPreview = <T extends UploadNeedingPreview>(uploads: T[]) =>
  uploads
    .filter((upload) => isPreviewAvailable(upload) && !upload.imageBase64 && !upload.previewFailed)
    .slice(0, MAX_CONCURRENT_UPLOAD_PREVIEWS);
